// eslint-disable-next-line import/prefer-default-export
export const getSubmitText = (isLoading, isNew) => {
  if (isLoading && isNew) return 'creating...';
  if (isLoading && !isNew) return 'saving...';

  return isNew ? 'create' : 'save';
};
